import { render } from "./RequestRecap.vue?vue&type=template&id=66115e25&scoped=true"
import script from "./RequestRecap.vue?vue&type=script&lang=js"
export * from "./RequestRecap.vue?vue&type=script&lang=js"

import "./RequestRecap.vue?vue&type=style&index=0&id=66115e25&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66115e25"]])

export default __exports__